import { render, staticRenderFns } from "./DecorativePanel.vue?vue&type=template&id=1755936e&scoped=true&"
import script from "./DecorativePanel.vue?vue&type=script&lang=js&"
export * from "./DecorativePanel.vue?vue&type=script&lang=js&"
import style0 from "./DecorativePanel.vue?vue&type=style&index=0&id=1755936e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755936e",
  null
  
)

export default component.exports